import React, { Component } from 'react';
import TagStore from "../../stores/TagStore";
import TagActions from "../../actions/TagActions";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import LoadingComponent from "../pageComponent/LoadingComponent";

class UpdateTag extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id: this.props.id,
      tag: {
        id: this.props.id,
        TagKey: this.props.id,
        TagVisible: "",
        PlotMaxValue: "",
        TagDispName: "",
        TagUnit: "",
        TypeDesc: "",
        PlotMinValue: "",
        RejMinValue: "",
        TagDesc: "",
        PlotColor: "",
        TypeType: "",
        RejMaxValue: "",
        DBArchive: "",
        TagName: "",
        TagOffset: "",
        Precision: "",
        PlotLogScale: "",
        TypeUnitFactor: "",
        TypeUnit: "",
        // TagJEPName:"T"+this.props.id
      },
      checkbox: false,
      validateName: true,
      validateShortName: true,
      validatePrecision: true,
      validatePlotMin: true,
      validatePlotMax: true,
      validateRejectMin: true,
      validateRejectMax: true,
      dataLoading: false
    };

    this._onChange = this._onChange.bind(this);
    this.createNotification = this.createNotification.bind(this);
    this.checkTagName = this.checkTagName.bind(this);
    this.checkTagShortName = this.checkTagShortName.bind(this);
    this.checkPrecision = this.checkPrecision.bind(this);
    this.checkPlotMin = this.checkPlotMin.bind(this);
    this.checkPlotMax = this.checkPlotMax.bind(this);
    this.checkRejectMin = this.checkRejectMin.bind(this);
    this.checkRejectMax = this.checkRejectMax.bind(this);
    this.updateTag = this.updateTag.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  componentDidMount() {
    TagStore.addChangeListener(this._onChange);
    TagActions.loadTagRequest(this.props.id);
  }

  componentWillUnmount() {
    TagStore.removeChangeListener(this._onChange);
  }

  createNotification(type) {
    try {
      switch (type) {
        case 'updated':
          return NotificationManager.success('Tag updated successfully', 'TAG UPDATED', 3000);
        case 'NameExist':
          return NotificationManager.error('Unable to Add, Tag Name Already Exist', 'ERROR MESSAGE', 3000);
        case 'error':
          return NotificationManager.error('Could not add this Tag, please try later', 'ERROR MESSAGE', 3000);
        default:
          return NotificationManager.info('Please chose an action', 'INFO MESSAGE', 3000);
      }
    } catch (e) {
      console.log('createNotification function in UpdateTag', e)
    }
  };

  checkTagName() {
    try {
      const tagName = this.state.tag.TagName;
      const pattern = "[A-Za-z]{1,32}";
      let isFieldValid = false;
      if (tagName.trim() !== '') {
        if (tagName.match(pattern)) {
          isFieldValid = true;
          this.setState({ validateName: true });
          document.getElementById('TagName').className = "form-control form-control-sm mb-5";
          document.getElementById('tagNameError').style.display = "none";
        } else {
          document.getElementById('TagName').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('tagNameError').style.display = "block";
          document.getElementById('tagNameError').innerHTML = " Invalidate Tag Name.";
          isFieldValid = false;
          this.setState({ validateName: false });
        }
      } else {
        document.getElementById('TagName').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('tagNameError').style.display = "block";
        document.getElementById('tagNameError').innerHTML = " Tag Name can not be empty.";
        isFieldValid = false;
        this.setState({ validateName: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log('checkTagName function in UpdateTag ', e)
    }
  }

  checkTagShortName() {
    try {
      const tagShortName = this.state.tag.TagDispName;
      const pattern = "[A-Za-z]{1,32}";
      let isFieldValid = false;
      if (tagShortName.trim() !== '') {
        if (tagShortName.match(pattern)) {
          isFieldValid = true;
          this.setState({ validateShortName: true });
          document.getElementById('TagDispName').className = "form-control form-control-sm mb-5";
          document.getElementById('tagShortNameError').style.display = "none";
        } else {
          document.getElementById('TagDispName').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('tagShortNameError').style.display = "block";
          document.getElementById('tagShortNameError').innerHTML = " Invalidate Display name.";
          isFieldValid = false;
          this.setState({ validateShortName: false });
        }
      } else {
        document.getElementById('TagDispName').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('tagShortNameError').style.display = "block";
        document.getElementById('tagShortNameError').innerHTML = "Display name can not be empty.";
        isFieldValid = false;
        this.setState({ validateShortName: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log('checkTagShortName function in UpdateTag ', e)
    }
  }

  checkPrecision() {
    try {
      const precision = this.state.tag.Precision;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (precision.trim() !== '') {
        if (pattern.test(precision)) {
          isFieldValid = true;
          this.setState({ validatePrecision: true });
          document.getElementById('Precision').className = "form-control form-control-sm mb-5";
          document.getElementById('precisionError').style.display = "none";
        } else {
          document.getElementById('Precision').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('precisionError').style.display = "block";
          document.getElementById('precisionError').innerHTML = " Invalidate Precision value.";
          isFieldValid = false;
          this.setState({ validatePrecision: false });
        }
      } else {
        document.getElementById('Precision').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('precisionError').style.display = "block";
        document.getElementById('precisionError').innerHTML = " Precision can not be empty.";
        isFieldValid = false;
        this.setState({ validatePrecision: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log('checkPrecision function in UpdateTag ', e)
    }
  }

  checkPlotMin() {
    try {
      const plotMin = this.state.tag.PlotMinValue;
      const plotMax = this.state.tag.PlotMaxValue;
      let isFieldValid = false;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      if (plotMin.toString().trim() !== '') {
        if (pattern.test(plotMin)) {
          if (parseFloat(plotMin) >= parseFloat(plotMax)) {
            isFieldValid = false;
            this.setState({ validatePlotMin: false });
            document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('plotMinError').style.display = "block";
            document.getElementById('plotMinError').innerHTML = " Plot min value can not be equal / greater than Plot max value.";
          } else {
            if (document.getElementById('plotMaxError').style.display === "block") {
              document.getElementById('plotMaxError').style.display = "none";
              document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5";
              this.setState({ validatePlotMax: true });
            }
            isFieldValid = true;
            this.setState({ validatePlotMin: true });
            document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5";
            document.getElementById('plotMinError').style.display = "none";
          }
        } else {
          document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('plotMinError').style.display = "block";
          document.getElementById('plotMinError').innerHTML = " Invalidate Plot min value.";
          isFieldValid = false;
          this.setState({ validatePlotMin: false });
        }
      } else {
        document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('plotMinError').style.display = "block";
        document.getElementById('plotMinError').innerHTML = " Plot min can not be empty.";
        isFieldValid = false;
        this.setState({ validatePlotMin: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log('checkPlotMin function in UpdateTag ', e)
    }
  }

  checkPlotMax() {
    try {
      const plotMax = this.state.tag.PlotMaxValue;
      const plotMin = this.state.tag.PlotMinValue;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (plotMax.toString().trim() !== '') {
        if (pattern.test(plotMax)) {
          if (parseFloat(plotMax) <= parseFloat(plotMin)) {
            isFieldValid = false;
            this.setState({ validatePlotMax: false });
            document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('plotMaxError').style.display = "block";
            document.getElementById('plotMaxError').innerHTML = " Plot max value can not be equal / less than Plot min value.";
          } else {
            if (document.getElementById('plotMinError').style.display === "block") {
              document.getElementById('plotMinError').style.display = "none";
              document.getElementById('PlotMinValue').className = "form-control form-control-sm mb-5";
              this.setState({ validatePlotMin: true });
            }
            isFieldValid = true;
            this.setState({ validatePlotMax: true });
            document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5";
            document.getElementById('plotMaxError').style.display = "none";
          }
        } else {
          document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('plotMaxError').style.display = "block";
          document.getElementById('plotMaxError').innerHTML = " Invalidate Plot max value.";
          isFieldValid = false;
          this.setState({ validatePlotMax: false });

        }
      } else {
        document.getElementById('PlotMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('plotMaxError').style.display = "block";
        document.getElementById('plotMaxError').innerHTML = " Plot max can not be empty.";
        isFieldValid = false;
        this.setState({ validatePlotMax: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log('checkPlotMax function in UpdateTag ', e)
    }
  }

  checkRejectMin() {
    try {
      const rejectMin = this.state.tag.RejMinValue;
      const rejectMax = this.state.tag.RejMaxValue;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (rejectMin.toString().trim() !== '') {
        if (pattern.test(rejectMin)) {
          if (parseFloat(rejectMin) >= parseFloat(rejectMax)) {
            isFieldValid = false;
            this.setState({ validateRejectMin: false });
            document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('rejectMinError').style.display = "block";
            document.getElementById('rejectMinError').innerHTML = " Reject min value can not be equal / greater than Reject max value.";
          } else {
            if (document.getElementById('rejectMaxError').style.display === "block") {
              document.getElementById('rejectMaxError').style.display = "none";
              document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5";
              this.setState({ validateRejectMax: true });
            }
            isFieldValid = true;
            this.setState({ validateRejectMin: true });
            document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5";
            document.getElementById('rejectMinError').style.display = "none";
          }
        } else {
          document.getElementById('Precision').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('rejectMinError').style.display = "block";
          document.getElementById('rejectMinError').innerHTML = " Invalidate Reject min value.";
          isFieldValid = false;
          this.setState({ validateRejectMin: false });
        }
      } else {
        document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('rejectMinError').style.display = "block";
        document.getElementById('rejectMinError').innerHTML = " Reject min can not be empty.";
        isFieldValid = false;
        this.setState({ validateRejectMin: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log('checkRejectMin function in UpdateTag ', e)
    }
  }

  checkRejectMax() {
    try {
      const rejectMin = this.state.tag.RejMinValue;
      const rejectMax = this.state.tag.RejMaxValue;
      const pattern = new RegExp("^\\d+(\\.\\d+)?$");
      let isFieldValid = false;
      if (rejectMax.toString().trim() !== '') {
        if (pattern.test(rejectMax)) {
          if (parseFloat(rejectMax) <= parseFloat(rejectMin)) {
            isFieldValid = false;
            this.setState({ validateRejectMax: false });
            document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
            document.getElementById('rejectMaxError').style.display = "block";
            document.getElementById('rejectMaxError').innerHTML = " Reject max value can not be equal / less than Reject min value.";
          } else {
            if (document.getElementById('rejectMinError').style.display === "block") {
              document.getElementById('rejectMinError').style.display = "none";
              document.getElementById('RejMinValue').className = "form-control form-control-sm mb-5";
              this.setState({ validateRejectMin: true });
            }
            isFieldValid = true;
            this.setState({ validateRejectMax: true });
            document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5";
            document.getElementById('rejectMaxError').style.display = "none";
          }
        } else {
          document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
          document.getElementById('rejectMaxError').style.display = "block";
          document.getElementById('rejectMaxError').innerHTML = " Invalidate Reject max value.";
          isFieldValid = false;
          this.setState({ validateRejectMax: false });

        }

      } else {
        document.getElementById('RejMaxValue').className = "form-control form-control-sm mb-5 border border-danger";
        document.getElementById('rejectMaxError').style.display = "block";
        document.getElementById('rejectMaxError').innerHTML = " Reject max can not be empty.";
        isFieldValid = false;
        this.setState({ validateRejectMax: false });
      }
      return isFieldValid;
    } catch (e) {
      console.log('checkRejectMax function in UpdateTag ', e)
    }
  }

  updateTag(event) {
    try {
      event.preventDefault();
      if (this.checkTagName() &&
        this.checkTagShortName() &&
        this.checkPrecision() &&
        this.checkPlotMin() &&
        this.checkPlotMax() &&
        this.checkRejectMin() &&
        this.checkRejectMax()) {
        let t = this.state.tag;
        const DBArchive = document.getElementById("DBArchive");
        DBArchive.checked === true ? t.DBArchive = "1" : t.DBArchive = "0";
        t.TagName = t.TagName.trim();
        t.TypeDesc = t.TagName;
        t.TagDesc = t.TagName;
        const color = this.hexToRgb(t.PlotColor.substr(1, t.PlotColor.length));
        t.PlotColor = color.r + "," + color.g + "," + color.b;
        this.setState({ tag: t });
        TagActions.updateTag(this.state.tag);
        this.props.hideModal();
      }
    } catch (e) {
      console.log('updateTag function in UpdateTag ', e)
    }
  }

  componentToHex(c) {
    try {
      let hex = c.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    } catch (e) {
      console.log('componentToHex function in UpdateTag ', e)
    }
  }

  rgbToHex(r, g, b) {
    try {
      return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    } catch (e) {
      console.log('rgbToHex function in UpdateTag ', e)
    }
  }

  hexToRgb(hex) {
    try {
      let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    } catch (e) {
      console.log('hexToRgb function in UpdateTag ', e)
    }
  }

  updateState(event) {
    try {
      const field = event.target.id;
      const value = event.target.value;
      let t = this.state.tag;
      t[field] = value;
      this.setState({ tag: t });
    } catch (e) {
      console.log('updateState function in UpdateTag ', e)
    }
  }

  render() {
    return (
      <React.Fragment>
        <LoadingComponent isLoading={this.state.dataLoading} />
        <form className="">
          <div className="row mt-10">
            <div className="col-sm-6">
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="TagName">Tag Name : <span
                  className="text-danger">*</span></label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event);
                    this.checkTagName();
                  }} value={this.state.tag.TagName} type="text" className="form-control form-control-sm mb-5"
                    id="TagName"
                    pattern="[A-Za-z]{1,32}"
                    maxLength={"100"}
                  />
                  <div id="tagNameError" style={{ display: 'none' }} className="invalid-feedback">
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="TagUnit">Unit :</label>
                <div className="col-sm-7">
                  <input maxLength={"21"} onChange={(event) => {
                    this.updateState(event)
                  }} value={this.state.tag.TagUnit} type="text" className="form-control form-control-sm mb-5"
                    id="TagUnit" placeholder="" />
                </div>
              </div>
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="PlotMinValue">Plot Min : <span
                  className="text-danger">*</span></label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event);
                    this.checkPlotMin();
                  }} value={this.state.tag.PlotMinValue} type="number"
                    className="form-control form-control-sm mb-5" id="PlotMinValue"
                    pattern="^\d+(\.\d+)?$"
                  />
                  <div id="plotMinError" style={{ display: 'none' }} className="invalid-feedback">
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="RejMinValue">Reject Min : <span
                  className="text-danger">*</span></label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event);
                    this.checkRejectMin();
                  }} value={this.state.tag.RejMinValue} type="number"
                    className="form-control form-control-sm mb-5" id="RejMinValue"
                    pattern="^\d+(\.\d+)?$"
                  />
                  <div id="rejectMinError" style={{ display: 'none' }} className="invalid-feedback">
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="PlotColor">Color :</label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event)
                  }} value={this.state.tag.PlotColor !== "" ? this.state.tag.PlotColor : "#000000"} type="color"
                    className="form-control form-control-sm mb-5" id="PlotColor" placeholder="" />
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="TagDispName">Display Name : <span
                  className="text-danger">*</span></label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event);
                    this.checkTagShortName();
                  }} value={this.state.tag.TagDispName} type="text" className="form-control form-control-sm mb-5"
                    id="TagDispName"
                    pattern="[A-Za-z]{1,32}"
                    maxLength={"100"}
                  />
                  <div id="tagShortNameError" style={{ display: 'none' }} className="invalid-feedback">
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="Precision">Precision : <span
                  className="text-danger">*</span></label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event);
                    this.checkPrecision();
                  }} value={this.state.tag.Precision} type="number" className="form-control form-control-sm mb-5"
                    id="Precision"
                    pattern="^\d+(\.\d+)?$"
                  />
                  <div id="precisionError" style={{ display: 'none' }} className="invalid-feedback">
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="PlotMaxValue">Plot Max : <span
                  className="text-danger">*</span></label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event);
                    this.checkPlotMax();
                  }} value={this.state.tag.PlotMaxValue} type="number"
                    className="form-control form-control-sm mb-5" id="PlotMaxValue"
                    pattern="^\d+(\.\d+)?$"
                  />
                  <div id="plotMaxError" style={{ display: 'none' }} className="invalid-feedback">
                  </div>
                </div>
              </div>
              <div className="row">
                <label className="control-label col-sm-5" htmlFor="RejMaxValue">Reject Max : <span
                  className="text-danger">*</span></label>
                <div className="col-sm-7">
                  <input onChange={(event) => {
                    this.updateState(event);
                    this.checkRejectMax();
                  }} value={this.state.tag.RejMaxValue} type="number"
                    className="form-control form-control-sm mb-5" id="RejMaxValue"
                    pattern="^\d+(\.\d+)?$"
                  />
                  <div id="rejectMaxError" style={{ display: 'none' }} className="invalid-feedback">
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" form-check pl-1 pl-15">
                  <input onChange={() => {
                    this.setState({ checkbox: !this.state.checkbox })
                  }} checked={this.state.checkbox} type="checkbox" hidden={true} className="form-check-input"
                    id="DBArchive" />
                  <label className="form-check-label" htmlFor="DBArchive">Archive</label>
                </div>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-sm-offset-2 col-sm-12">
              <button className="btn btn-sm btn-primary mt-5 float-right"
                onClick={(event) => {
                  this.updateTag(event)
                }}
              >Save
              </button>
            </div>
          </div>
          <NotificationContainer />
        </form>
      </React.Fragment>
    )
  }

  _onChange() {
    try {
      const t = TagStore.getTag();
      this.setState({ dataLoading: TagStore.getIsLoading() })
      let tg = this.state.tag;
      (t.TagVisible !== undefined) ? tg.TagVisible = t.TagVisible : tg.TagVisible = "";
      (t.TagName !== undefined) ? tg.TagName = t.TagName : tg.TagName = "";
      (t.TagDispName !== undefined) ? tg.TagDispName = t.TagDispName : tg.TagDispName = "";
      (t.TagUnit !== undefined) ? tg.TagUnit = t.TagUnit : tg.TagUnit = "";
      (t.Precision !== undefined) ? tg.Precision = t.Precision : tg.Precision = "";
      (t.PlotMinValue !== undefined) ? tg.PlotMinValue = parseInt(t.PlotMinValue, 10).toFixed(1) : tg.PlotMinValue = "";
      (t.PlotMaxValue !== undefined) ? tg.PlotMaxValue = parseInt(t.PlotMaxValue, 10).toFixed(1) : tg.PlotMaxValue = "";
      (t.RejMinValue !== undefined) ? tg.RejMinValue = parseInt(t.RejMinValue, 10).toFixed(1) : tg.RejMinValue = "";
      (t.RejMaxValue !== undefined) ? tg.RejMaxValue = parseInt(t.RejMaxValue, 10).toFixed(1) : tg.RejMaxValue = "";
      const clr = (t.PlotColor !== undefined) ? t.PlotColor.split(',') : "#000000";
      tg.PlotColor = (t.PlotColor !== undefined) ? this.rgbToHex(parseInt(clr[0], 10), parseInt(clr[1], 10), parseInt(clr[2], 10)) : "#000000";
      (t.TypeDesc !== undefined) ? tg.TypeDesc = t.TypeDesc : tg.TypeDesc = "";
      (t.TagDesc !== undefined) ? tg.TagDesc = t.TagDesc : tg.TagDesc = "";
      (t.TypeType !== undefined) ? tg.TypeType = t.TypeType : tg.TypeType = "";
      (t.TagOffset !== undefined) ? tg.TagOffset = parseInt(t.TagOffset, 10) : tg.TagOffset = "";
      (t.PlotLogScale !== undefined) ? tg.PlotLogScale = t.PlotLogScale : tg.PlotLogScale = "";
      (t.TypeUnitFactor !== undefined) ? tg.TypeUnitFactor = t.TypeUnitFactor : tg.TypeUnitFactor = "";
      (t.TypeUnit !== undefined) ? tg.TypeUnit = t.TypeUnit : tg.TypeUnit = "";
      (t.DBArchive !== undefined) ? tg.DBArchive = t.DBArchive : tg.DBArchive = "";
      if (t.TagJEPName !== undefined) { tg.TagJEPName = t.TagJEPName };
      this.setState({ tag: tg });
      this.setState({ checkbox: this.state.tag.DBArchive.includes('1') });
    } catch (e) {
      console.log('_onChange function in UpdateTag ', e)
    }
  }
}

export default UpdateTag;